import React from 'react';
import { isMobile } from 'react-device-detect';

const TileSlider = ({ 
  sliderRef, 
  sliderStyle, 
  isDragging, 
  globalActiveInstance, 
  instanceId, 
  onMouseDown, 
  onTouchStart, 
  itemColumns, 
  columnWidth, 
  renderItem, 
  handleItemClick 
}) => {
  return (
  <div
    ref={sliderRef}
    style={sliderStyle}
    onMouseDown={isMobile ? onMouseDown : undefined}
    onTouchStart={isMobile ? onTouchStart : undefined}
  >
    {itemColumns.map((column, columnIndex) => (
      <div key={columnIndex}  style={{width: `max-content`}}>
        {column.map((item) => (
          <div key={item.id}  onClick={() => handleItemClick(item)}>
            {renderItem(item)}
          </div>
        ))}
      </div>
    ))}
  </div>
  );
};

export default TileSlider;
